//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import HrPayrollListView from '@/views/HumanResource/HrPayroll/HrPayrollList'
import HrPayrollCreateView from '@/views/HumanResource/HrPayroll/HrPayrollCreate'

//
export default {
    path: 'payroll',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'payroll-list',
            component: HrPayrollListView,
        },
        {
            path: 'create',
            name: 'payroll-create',
            component: HrPayrollCreateView,
            meta: {
                title: 'Crear nomina de sueldo',
            },
        },
    ],
    meta: {
        title: 'Nominas de sueldo',
    },
}
